import { NextAppBaseError, } from './NextAppBaseError';
export class PermissionError extends NextAppBaseError {
    static className = 'PermissionError';
    missingPermissions;
    constructor(props) {
        super(props);
        this.missingPermissions = props.missingPermissions ?? [];
    }
    convertToJSON(debug) {
        const props = {
            ...super.convertToJSON(debug),
            missingPermissions: debug ? this.missingPermissions : undefined,
        };
        return props;
    }
    assignJSON(json) {
        if (!super.assignJSON(json))
            return false;
        this.missingPermissions = Array.isArray(json?.missingPermissions)
            ? json?.missingPermissions
            : [];
        return true;
    }
    getStatusCode() {
        return 403;
    }
}
